import { useQuery} from '@tanstack/react-query';
import {useAuth} from '@/contexts/AuthContext';
import {ReitService as reitService} from '@/services/investments';

/**
 * Custom hook to fetch Real Estate Investment Trust (REIT) holdings for the authenticated user.
 *
 * This hook uses the `useQuery` hook from React Query to asynchronously retrieve the user's REIT holdings
 * data from the backend service. The query is only enabled when a user is authenticated.
 *
 * @return {object} Returns the object provided by the `useQuery` hook, containing query status, data, and additional helper methods.
 */
export default function useFetchReitHoldings() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['reit_holdings', user?.id],
    queryFn: async () => {
      return await reitService.getHoldings(user!.id)
    },
    enabled: !!user,
  });
}
